import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'

const LinkedinWarning = (props) => {
    const { certificationStore } = props
    const {
        showLinkedinWarning,
        toggleShowLinkedinWarning,
        download,
    } = certificationStore
    const link = 'https://kb.explori.com/knowledge/share-certificate-on-linkedin?hs_preview=dXhrmcJI-192876804651'

    return (
        <Modal show={!!showLinkedinWarning} onClose={toggleShowLinkedinWarning}>
            <div className="uc-modal__header">
                <Typography type="h2">{i18n.t('certification.linkedinWarning.title')}</Typography>
                <div className="uc-modal__desc">
                    <Typography type="p">{i18n.t('certification.linkedinWarning.subTitle')}</Typography>
                </div>
            </div>
            <p
                dangerouslySetInnerHTML={{ __html: i18n.t('certification.linkedinWarning.body', { link }) }}
                style={{ textAlign: 'center' }}
            />
            <div className="uc-modal__button-panel" style={{ justifyContent: 'space-between' }}>
                <Button
                    className="regular"
                    variant="tertiary"
                    label={i18n.t('certification.linkedinWarning.shareAuto')}
                    onClick={() => {
                        certificationStore.showLinkedIn = true
                        toggleShowLinkedinWarning()
                    }}
                />
                <Button
                    className="regular"
                    variant="tertiary"
                    label={i18n.t('certification.linkedinWarning.shareManual')}
                    onClick={() => {
                        download()
                        toggleShowLinkedinWarning()
                    }}
                />
            </div>
        </Modal>
    )
}

export default observer(LinkedinWarning)
